import { useEffect, useState } from "react";
import axios from "../axios";

export default function useMissingLessons() {
  const [missingLessons, setMissingLessons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("teacher/missing-mark")
      .then((res) => setMissingLessons(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return { missingLessons, loading };
}
